import React, { Fragment, useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Link,
  useLocation,
  useSearchParams,
  createSearchParams,
  useNavigate,
  useHistory,
} from "react-router-dom";
import { Dropdown, Modal, Button } from "react-bootstrap";
import { db } from "../../../../firebase";
import {
  collection,
  updateDoc,
  doc,
  query,
  limit,
  deleteDoc,
  orderBy,
  where,
  Query,
  or,
  and,
} from "firebase/firestore";

import PageTitle from "../../../layouts/PageTitle";
import AccountantItem from "./AccItem";
import AccountantRegister from "./AccRegister";
import AccountantEdit from "./AccEdit";

import { usePagination } from "../../../../hook/usePagination";
import { useFirestore } from "../../../../hook/useFirestore";

import { useQuery } from "../../../../hook/useQuery";

const AccountantItemList = () => {
  const [saleItemList, setSaleItemList] = useState([]);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [itemEdit, setItemEdit] = useState({});

  const history = useHistory();
  const searchParams = useQuery();
  const param = searchParams.get("q");

  const searchRef = useRef(null);

  let QueryFilterConstraint = [];
  let queryRef = query(collection(db, "accountants"), orderBy("name", "asc"));

  if (param !== null) {
    QueryFilterConstraint.push(
      where("name", ">=", param),
      where("name", "<=", param + "\uf8ff")
    );

    queryRef = query(
      collection(db, "accountants"),
      and(...QueryFilterConstraint),
      orderBy("name", "asc")
    );
  }

  const {
    items: SaleInfo,
    isLoading,
    isStart,
    isEnd,
    getPrev,
    getNext,
  } = usePagination(queryRef, { limit: 20 });

  const { deleteDocument } = useFirestore("accountants");

  const handleSearchChange = () => {
    history.replace({
      search: new URLSearchParams({ q: searchRef.current.value }).toString(),
    });
  };

  const handleOnNewItem = () => {
    setShowRegisterModal(true);
  };

  const handleOnEdit = async (id) => {
    setItemEdit(saleItemList.find((c) => c.id === id));
    setShowEditModal(true);
  };

  const handleOnRegisterHide = (sn) => {
    setShowRegisterModal(false);
  };
  const handleOnEditHide = (sn) => {
    setShowEditModal(false);
  };

  const handleOnDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        deleteDocument(id)
          .then(() => {
            swal(`Poof! Your file has been deleted!`, {
              icon: "success",
            });
          })
          .catch((err) => {
            swal(`Poof! ${err}`, {
              icon: "error",
            });
          });
      } else {
        swal("Canceled");
      }
    });
  };

  useEffect(() => {
    setSaleItemList(SaleInfo);
  }, [SaleInfo]);

  return (
    <Fragment>
      <PageTitle activeMenu="Item List" motherMenu="Items" />
      <div className="form-head d-flex mb-3 mb-lg-5 align-items-center">
        <Button
          onClick={handleOnNewItem}
          className="btn btn-danger"
          data-toggle="tooltip"
          data-placement="top"
          title="Item Registration"
        >
          + New Accountant
        </Button>

        <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search Name"
            onChange={handleSearchChange}
            ref={searchRef}
          />
          <div className="input-group-append">
            <span className="input-group-text c-pointer">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div>
      </div>
      <AccountantRegister
        show={showRegisterModal}
        hide={handleOnRegisterHide}
      />
      <AccountantEdit
        item={itemEdit}
        show={showEditModal}
        hide={handleOnEditHide}
      />
      <AccountantItem
        items={saleItemList}
        onEdit={handleOnEdit}
        onDelete={handleOnDelete}
      />
    </Fragment>
  );
};

export default AccountantItemList;
